import _ from 'underscore';
import Promise from 'bluebird';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';
import {
  RecommendationService,
  CHANNEL_TYPES,
  getRecommendationIds,
} from '@bingads-webui-campaign/recommendation-core';
import { edmCampaign } from '@bingads-webui/edm-campaign';

const RECOMMENDATION_SUMMARY_TOP_NUMBER = 5;
let p$Opportunities = null;

export function fetchTips({
  cid,
  aid,
}) {
  if (!aid || !cid) {
    return Promise.resolve([]);
  }

  return edmCampaign
    .Customers
    .$withKey(cid)
    .Accounts
    .$withKey(aid)
    .Tips
    .get({
      top: 20,
      count: true,
    })
    .toPromise()
    .then(({ value }) => value);
}

const schema = {
  scenario: [
    {
      name: 'loadRecommendationTile',
      value: 'LoadRecommendationTab',
      setting: {},
      activity: [
        {
          name: 'loadRecommendationTile',
          value: 'LoadRecommendationTile',
        },
        {
          name: 'getSummary',
          value: 'getSummary',
        },
        {
          name: 'getCoupons',
          value: 'getCoupons',
        },
      ],
    },
  ],
};

export function getScope({
  navigationLevel,
  legacyConfig,
  cid,
  aid,
  campaignId,
}) {
  let levelAt;
  let entityIds;

  switch (navigationLevel) {
    case 'account':
      levelAt = levelAtConstant.ACCOUNT;
      entityIds = [aid];
      break;
    case 'campaign':
      levelAt = levelAtConstant.CAMPAIGN;
      entityIds = [campaignId];
      break;
    case 'customer':
      levelAt = levelAtConstant.CUSTOMER;
      entityIds = [cid];
      break;
    default:
  }

  const scope = {
    customerId: cid,
    accountId: aid,
    campaignId,
    campaignName: _.result(legacyConfig.get('CurrentCampaign'), 'Name'),
    token: legacyConfig.get('Token'),
    levelAt,
    entityIds,
  };

  return scope;
}

export function fetchMCCOverviewRecommendations({
  entitySet,
  jsdata,
  permissions,
}) {
  const isMCC = true;
  const multiAccountRecommendationParameters = {
    RecommendationTypes: getRecommendationIds(undefined, CHANNEL_TYPES.MCCOVERVIEW, permissions, isMCC),
  };

  const query = {
    entitySet: entitySet['Default.MultiAccountRecommendation'].$call({ multiAccountRecommendationParameters }).toJSON(),
  };

  return jsdata[entitySet.type.elementType.shortName].findAll({
    query,
  });
}

export function fetchRecommendations({
  navigationLevel,
  featureInstrumentation,
  legacyConfig,
  permissions,
  serverContext,
  campaignType,
  ccJsData,
  cid,
  aid,
  campaignId,
}) {
  if (p$Opportunities && navigationLevel === 'account') {
    return p$Opportunities;
  }

  const scope = getScope({
    navigationLevel,
    legacyConfig,
    cid,
    aid,
    campaignId,
  });

  if (!scope.accountId) {
    return Promise.resolve([]);
  }

  featureInstrumentation.addScenario(schema);
  const currentScenario = featureInstrumentation.loadRecommendationTile.create();
  const currentActivity = currentScenario.loadRecommendationTile.create();

  const dataService = new RecommendationService({
    scope,
    currentScenario,
    currentActivity,
    odataPath: legacyConfig.get('adinsight.odata.url'),
    permissions,
    lcid: serverContext.CurrentUser.LocaleID,
    ccJsData,
    channel: CHANNEL_TYPES.OVERVIEW,
  });

  const opportunities = dataService.getSummary({
    channel: CHANNEL_TYPES.OVERVIEW,
    campaignType,
    top: RECOMMENDATION_SUMMARY_TOP_NUMBER,
    ignoreCoupons: true,
  });

  if (navigationLevel === 'account') {
    p$Opportunities = opportunities;
  }

  return opportunities;
}

export function clearRecommendationsCache() {
  p$Opportunities = null;
}
